import React from 'react';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Tab, Tabs } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native scrollbars / form controls follow the active theme.
    colorScheme: theme.palette.type,
    '& .MuiPaper-root': {
      elevation: 3,
    },
  },
  userTable: {
    '& .MuiTableCell-root': {
      color: theme.palette.primary.gray,
    },
    '& .MuiTableCell-head': {
      color: theme.palette.primary.gray,
    },
    '& .MuiTableCell-paddingNone': {
      color: theme.palette.primary.mainBlue,
      fontWeight: 'bold',
    },
    '& .Mui-checked': {
      color: theme.palette.secondary.blue,
    },
    '& .MuiTableRow-root': {
      '&:hover': {
        backgroundColor: theme.palette.custom.tableRowHover,
      },
    },
    '& .Mui-selected': {
      backgroundColor: theme.palette.custom.tableRowHover,
    },
  },
  iconsCell: {
    '& svg': {
      color: theme.palette.primary.gray,
      cursor: 'pointer',
    },
  },
  roleCells: {
    fontSize: '11px',
  },
  toolbarButton: {
    flexGrow: 1,
  },
  toolbarTable: {
    '& .MuiOutlinedInput-root': {
      height: '35px',
      fontSize: '13px',
      width: '350px',
    },
    '& .Mui-focused': {
      border: `1px solid ${theme.palette.secondary.gray}`,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.secondary.lightGray,
    },
    '& .MuiOutlinedInput-adornedStart': {
      paddingLeft: '2px',
    },
    '& button': {
      backgroundColor: theme.palette.custom.inputBackground,
      color: theme.palette.secondary.gray,
      fontSize: '13.5px',
      '& svg': {
        color: theme.palette.secondary.gray,
      },
    },
    '& .MuiMenuItem-root': {
      color: theme.palette.custom.menuItemText,
    },
  },
  popper: {
    zIndex: 2,
    width: '110px',
    '& ul': {
      paddingBottom: '0px',
    },
  },
  titleOption: {
    borderBottom: `1px solid ${theme.palette.secondary.gray}`,
  },
  roleOption: {
    fontSize: '12px',
  },
  activeOption: {
    fontSize: '13.5px',
  },
  clearOption: {
    fontSize: '13.5px',
    borderTop: `1px solid ${theme.palette.secondary.gray}`,
  },
  noContent: {
    height: '710px',
  },
  progress: {
    height: '610px',
    display: 'table-cell',
    textAlign: 'center',
    padding: '50px',
    '& div': {
      color: theme.palette.primary.main,
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontWeight: '200',
    },
  },
  projectName: {
    paddingLeft: '16px',
  },
  reportName: {
    paddingLeft: '16px',
  },
  formWrapper: {
    width: '50vw',
    padding: '56px',
    paddingTop: '10px',
    paddingBottom: '20px',
    '& .MuiFormLabel-root': {
      color: theme.palette.custom.inputLabel,
      margin: '15px auto 8px',
      fontSize: '12px',
    },
    '& input': {
      backgroundColor: theme.palette.custom.inputBackground,
      padding: '10px',
    },
    '& .MuiSelect-root': {
      padding: '10px',
      fontSize: '13.5px',
    },
  },
  dialogWrapper: {
    width: '40vw',
    padding: '56px',
    paddingTop: '10px',
    paddingBottom: '20px',
  },
  dialogText: {
    padding: '30px',
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'row',
    gap: '24px',
    padding: '24px',
    maxWidth: '1200px',
    '& .MuiFormLabel-root': {
      color: theme.palette.secondary.darkGray,
    },
    '& .MuiFormControl-root': {
      margin: '10px auto',
    },
    '& input': {
      padding: '10px',
    },
    '& .MuiSelect-root': {
      padding: '10px',
      fontSize: '13.5px',
    },
  },
  itemList: {
    fontSize: '13.5px',
    color: theme.palette.custom.menuItemText,
  },
  role: {
    gridColumn: 1,
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 12px',
    gap: '8px',
    gridColumn: 2,
    '& button': {
      width: '100%',
      color: theme.palette.custom.solidButtonText,
      backgroundColor: theme.palette.custom.solidButtonBackground,
    },
    '& button:first-child': {
      color: theme.palette.secondary.gray,
      backgroundColor: theme.palette.custom.outlineButtonBackground,
      border: `1px solid ${theme.palette.secondary.gray}`,
    },
  },
  users: {
    display: 'table-cell',
    textAlign: 'center',
    padding: '50px',
    '& svg': {
      width: '40px',
      height: '40px',
      color: theme.palette.primary.main,
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontWeight: '200',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  tableHeader: {
    color: theme.palette.secondary.gray,
    '& .Mui-checked': {
      color: theme.palette.secondary.blue,
      opacity: 0.5,
    },
    '& .MuiCheckbox-indeterminate ': {
      color: theme.palette.secondary.blue,
      opacity: 0.5,
    },
  },
  title: {
    marginBottom: '5px',
  },
  tag: {
    borderRadius: '5px',
    padding: '5px 8px',
    maxWidth: '100px',
    margin: '0px auto',
  },
  tagActive: {
    color: theme.palette.custom.statusOpenText,
    backgroundColor: theme.palette.custom.statusOpenBackground,
  },
  tagInactive: {
    color: theme.palette.custom.statusPendingText,
    backgroundColor: theme.palette.custom.statusPendingBackground,
  },
  tagBlocked: {
    color: theme.palette.custom.statusBlockedText,
    backgroundColor: theme.palette.custom.statusBlockedBackground,
  },
  editDeleteButtons: {
    marginRight: '20px',
    '& .MuiIconButton-root': {
      width: '35px',
      '&:hover': {
        backgroundColor: theme.palette.custom.cardBackground,
      },
    },
  },
  sizeMessage: {
    fontSize: '12px',
    color: theme.palette.secondary.gray,
  },
  red: {
    color: `${theme.palette.custom.dangerIcon} !important`,
  },
  gray: {
    color: `${theme.palette.custom.disabledIcon} !important`,
  },
}));

export const StyledTabs = withStyles((theme) => ({
  indicator: {
    backgroundColor: theme.palette.secondary.blue,
  },
}))(Tabs);

export const StyledTab = withStyles((theme) => ({
  root: {
    minWidth: '75px',
    textTransform: 'none',
    padding: '0px 8px',
    margin: '0px 10px',
    color: theme.palette.primary.gray,
  },
}))((props) => <Tab disableRipple {...props} />);

export default useStyles;
